<template>
  <AppLink
    to="/"
    class="logo"
  >
    <img
      src="/dille-kamille.svg"
      alt="Dille & Kamille"
      class="logo__image"
      width="4777"
      height="3500"
    >
  </AppLink>
</template>

<script setup lang="ts">
defineProps({
  color: {
    type: String,
    default: 'white',
  },

})
</script>

<!-- <style src="~layers/app/components/App/Logo.css" /> -->
<style>
@import url("~layers/app/components/App/Logo.css");
</style>
